import React from 'react';
import { ArrowRight } from 'lucide-react';

const GlobalBanner = () => {
  return (
    <div className="bg-[#0EA5E9] text-white py-2.5 px-4 sticky top-0 z-[60]">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center">
        <p className="text-sm font-medium">
          Get Your Instant HVAC Estimate in Minutes — No Phone Call Required
        </p>
        <a
          href="/instant-hvac-estimate-new-orleans"
          className="inline-flex items-center gap-1.5 bg-white text-[#0EA5E9] px-4 py-1.5 rounded-full text-sm font-bold hover:bg-slate-100 transition-colors"
        >
          Start My Estimate
          <ArrowRight className="w-4 h-4" />
        </a>
      </div>
    </div>
  );
};

export default GlobalBanner;
